
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/image-list-item-bar",
      function () {
        return require("private-next-pages/material-ui/api/image-list-item-bar.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/image-list-item-bar"])
      });
    }
  